import styled from 'styled-components';
import { colors } from "colors";


export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 4px;
  box-shadow: 1px 1px 4px 1px ${colors.paleGrey};
  margin: 16px 0;
`;

export const PanelTitleWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  height: 48px;
  box-shadow: 0 1px 0 0 ${colors.paleGrey};
  font-size: 14px;
  
  >:nth-child(2) {
    display: flex;
    justify-content: space-between;
    width: 320px;

    >:first-child {
      flex: 0.35;
      text-align: end;
    }

    >:last-child {
      flex: 0.65;
    }
  }
`;

export const WorkOrderStatus = styled.p`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-weight: bold;

  span.circle {
    display: inline-block;
    border-radius: 8px;
    padding: 8px;
    margin: 0 8px 0 0;
  }

  &.open {
    color: ${colors.coral};
  }
  span.circle.open {
    background-color: ${colors.coral};
  }

  &.inProgress {
    color: ${colors.shamrockGreen};
  }
  span.circle.inProgress {
    background-color: ${colors.shamrockGreen};
  }

  &.onHold {
    color: ${colors.marigold};
  }
  span.circle.onHold {
    background-color: ${colors.marigold};
  }

  &.complete {
    color: ${colors.steel};
  }
  span.circle.complete {
    background-color: ${colors.steel};
  }
`;

export const PanelContentWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-flow: row wrap;
  flex-direction: row;
  
  font-size: 14px;
  color: ${colors.charcoalGrey};
  line-height: 1.5em;
`;

export const RequestNumberWrapper = styled.span`
  display: flex;
  flex-shrink: 1;

  p, span {
    margin: 0 0 8px 0;
    border-radius: 4px;
    background-color: ${colors.lightGrey};
    padding: 8px;
    height: 16px;
    text-align: center;
    color: ${colors.steel};
    font-weight: bold;
  }
`;

export const RequestContentWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex: 1;
`;

export const RequestInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 0 0 16px;
  min-width: 256px;
  
  pre {
    padding: 8px 0;
    white-space: pre-wrap;
  }
`;

export const RequesterInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 0 16px;
  min-width: 256px;
  
  > div > span {
    display: flex;
    justify-content: space-between;
    width: 320px;
    float: end;
    
    >:first-child {
      flex: 0.35;
      text-align: end;
    }

    >:last-child {
      flex: 0.65;
    }
  }
`;

export const WorkOrderTitle = styled.span`
  font-weight: bold;
  font-size: 16px;
  color: ${colors.charcoalGrey};
`;

export const Label = styled.span`
  font-weight: bold;
  color: ${colors.charcoalGrey};
  p {
    margin: 0;
  }
  span, a {
    font-weight: normal;
    margin-left: 16px;
  }
`;

export const FileLinkWrapper = styled.a`
  display: flex;
  align-items: center;
  svg {
    padding: 4px;
    width: 12px;
    height: 12px;
    fill: ${colors.brightBlue};
    background-color: ${colors.iceBlue};
    border-radius: 4px;
  }
  span {
    margin-left: 8px;
    color: ${colors.brightBlue};
  }
`;
